import React from "react";
import {useSelector} from "react-redux";

import {Container} from "@pg-design/grid-module";
import {mb, ph} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {useResponsiveLinkTarget} from "../../hooks/useResponsiveLinkTarget";
import {SiteMapBox} from "../components/SiteMapBox";
import {SiteMapHeading} from "../components/SiteMapHeading";
import {siteMapLinkDefinedPrefixes, SiteMapLinkList} from "../components/SiteMapLinkList";

const staticLinks = [
    {href: "https://rynekpierwotny.pl/deweloperzy/s/slupsk/", text: "Deweloperzy Słupsk"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/opole/", text: "Deweloperzy Opole"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/bielsko-biala/", text: "Deweloperzy Bielsko-Biała"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/pruszcz-gdanski/", text: "Deweloperzy Pruszcz Gdański"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/koszalin/", text: "Deweloperzy Koszalin"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/czestochowa/", text: "Deweloperzy Częstochowa"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/rybnik/", text: "Deweloperzy Rybnik"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/nowy-dwor-mazowiecki/", text: "Deweloperzy Nowy Dwór Mazowiecki"}
];

export const SiteMapVendors = () => {
    const responsiveLinkTarget = useResponsiveLinkTarget();

    const vendorLinks =
        useSelector((state: IRPStore) => state.siteMap.vendors)?.map((vendor) => ({
            href: rpAppLink.vendor.detail.base({
                vendorId: vendor.id,
                vendorSlug: vendor.slug
            }),
            text: vendor.name
        })) || [];

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem name="Mapa strony" position="2" url={rpAppLink.siteMap.base()} />
                <BreadcrumbsItem name="Mapa strony - Deweloperzy" position="3" url={rpAppLink.siteMap.vendor()} isLinkingToCurrentLocation />
            </Breadcrumbs>

            <article>
                <SiteMapHeading>Mapa strony - Deweloperzy</SiteMapHeading>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapLinkList links={vendorLinks} variant="body_copy_2" gap={0} target={responsiveLinkTarget} />
                </SiteMapBox>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapBox.Header as="h2" css={[ph(3)]}>
                        Na skróty
                    </SiteMapBox.Header>

                    <SiteMapLinkList links={staticLinks} textPrefix={siteMapLinkDefinedPrefixes.bullet} variant="body_copy_2" gap={0} />
                </SiteMapBox>
            </article>
        </Container>
    );
};
import React from "react";
import {useSelector} from "react-redux";

import {Container} from "@pg-design/grid-module";
import {mb, ph} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {useResponsiveLinkTarget} from "../../hooks/useResponsiveLinkTarget";
import {SiteMapBox} from "../components/SiteMapBox";
import {SiteMapHeading} from "../components/SiteMapHeading";
import {siteMapLinkDefinedPrefixes, SiteMapLinkList} from "../components/SiteMapLinkList";

const staticLinks = [
    {href: "https://rynekpierwotny.pl/deweloperzy/s/slupsk/", text: "Deweloperzy Słupsk"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/opole/", text: "Deweloperzy Opole"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/bielsko-biala/", text: "Deweloperzy Bielsko-Biała"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/pruszcz-gdanski/", text: "Deweloperzy Pruszcz Gdański"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/koszalin/", text: "Deweloperzy Koszalin"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/czestochowa/", text: "Deweloperzy Częstochowa"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/rybnik/", text: "Deweloperzy Rybnik"},
    {href: "https://rynekpierwotny.pl/deweloperzy/s/nowy-dwor-mazowiecki/", text: "Deweloperzy Nowy Dwór Mazowiecki"}
];

export const SiteMapVendors = () => {
    const responsiveLinkTarget = useResponsiveLinkTarget();

    const vendorLinks =
        useSelector((state: IRPStore) => state.siteMap.vendors)?.map((vendor) => ({
            href: rpAppLink.vendor.detail.base({
                vendorId: vendor.id,
                vendorSlug: vendor.slug
            }),
            text: vendor.name
        })) || [];

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem name="Mapa strony" position="2" url={rpAppLink.siteMap.base()} />
                <BreadcrumbsItem name="Mapa strony - Deweloperzy" position="3" url={rpAppLink.siteMap.vendor()} isLinkingToCurrentLocation />
            </Breadcrumbs>

            <article>
                <SiteMapHeading>Mapa strony - Deweloperzy</SiteMapHeading>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapLinkList links={vendorLinks} variant="body_copy_2" gap={0} target={responsiveLinkTarget} />
                </SiteMapBox>

                <SiteMapBox css={[mb(4)]}>
                    <SiteMapBox.Header as="h2" css={[ph(3)]}>
                        Na skróty
                    </SiteMapBox.Header>

                    <SiteMapLinkList links={staticLinks} textPrefix={siteMapLinkDefinedPrefixes.bullet} variant="body_copy_2" gap={0} />
                </SiteMapBox>
            </article>
        </Container>
    );
};
